import { Commit } from 'vuex'
import { CustomModalProps, IModalBase, VueComponentContent, VueComponentFooter, VueComponentHeader } from '@/interfaces'
import { ModalLayer, ModalType } from '@/components/modals/modals-util'
import { IModalState } from '@/store/custom-modal.module'

// in case i18n is needed in the future...
// import i18n from '@/i18n'
// i18n.global.t('some-translation', { someParam: someValue })

export interface IModalProps {
  modalType: ModalType | null
  isOverlayModalOpen?: boolean
  componentContent?: VueComponentContent | null
  componentHeader?: VueComponentHeader | null
  componentFooter?: VueComponentFooter | null
  props?: CustomModalProps
  payload?: Record<string, unknown>
}

export interface IOverlayModal {
  modalLayer: ModalLayer.Overlay
  isOverlayModalOpen: boolean
}

export type IOverlayModalState = IOverlayModal & IModalBase

const basicState = {
  componentContent: null,
  componentHeader: null,
  componentFooter: null,
  props: {},
  payload: {}
}

export const overlayModal = {
  namespaced: true,
  state: (): IOverlayModalState => ({
    modalLayer: ModalLayer.Overlay,
    modalState: basicState,
    loading: false,
    isSubmitting: false,
    modalType: null,
    isOverlayModalOpen: false
  }),
  mutations: {
    openModal(state: IOverlayModalState, modalPayload: IModalProps) {
      const { props, modalType, componentContent, componentHeader, componentFooter, payload } = modalPayload
      state.loading = false
      state.isSubmitting = false
      state.modalType = modalType
      state.modalState = {
        componentContent: componentContent || null,
        componentHeader: componentHeader || null,
        componentFooter: componentFooter || null,
        props: props || {},
        payload: payload || {}
      }
      state.isOverlayModalOpen = true
    },

    closeModal(state: IOverlayModalState) {
      state.modalState = basicState
      state.modalType = null
      state.isOverlayModalOpen = false
    },
    setActionValidation(state: IModalState, payload: boolean) {
      if (state.modalState.props.footerProps) {
        state.modalState.props.footerProps.isConfirmValid = payload
      }
    },
    setModalProps(state: IModalState, payload: Record<string, unknown>) {
      state.modalState.props = { ...state.modalState.props, ...payload }
    },
    setModalPayload(state: IModalState, payload: Record<string, unknown>) {
      state.modalState.payload = { ...payload }
    },
    startSubmitting(state: IModalState) {
      state.isSubmitting = true
    }
  },
  actions: {
    openModal({ commit }: { commit: Commit }, payload: IModalProps) {
      commit('openModal', payload)
    },
    closeModal({ commit }: { commit: Commit }) {
      commit('closeModal')
    },
    setActionValidation({ commit }: { commit: Commit }, payload: boolean) {
      commit('setActionValidation', payload)
    },
    setModalPayload({ commit }: { commit: Commit }, payload: Record<string, unknown>) {
      commit('setModalPayload', payload)
    },
    setModalProps({ commit }: { commit: Commit }, payload: IModalProps) {
      commit('setModalProps', payload)
    },
    startSubmitting({ commit }: { commit: Commit }) {
      commit('startSubmitting')
    },
    stopSubmitting({ commit }: { commit: Commit }) {
      commit('startSubmitting')
    }
  },
  getters: {
    getOverlayModal: (state: IOverlayModal) => () => {
      return state
    },
    getIsOverlayModalOpen: (state: IOverlayModalState) => () => {
      return state.isOverlayModalOpen
    },
    getModalExtraProps: (state: IModalState) => () => {
      return state.modalState.props.extraProps
    },
    getModalPayload: (state: IModalState) => () => {
      return state.modalState.payload
    },
    getModalType: (state: IModalState) => () => {
      return state.modalType
    }
  }
}
